import React, { useState, useRef, useLayoutEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp, faAngleDown } from "@fortawesome/free-solid-svg-icons";

const Description = ({ htmlContent }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const descriptionRef = useRef(null);

  useLayoutEffect(() => {
    if (descriptionRef.current) {
      // Check if the content is overflowing its container
      const isOverflowing =
        descriptionRef.current.scrollHeight >
        descriptionRef.current.clientHeight;
      setShowButton(isOverflowing);
    }
  }, [htmlContent]);

  if (!htmlContent) {
    return null;
  }

  return (
    <div className="text-14 lh-15 mt-10">
      <div
        ref={descriptionRef}
        className={`description ${isExpanded ? "expanded" : "collapsed"}`}
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />

      {showButton && (
        <button
          onClick={() => setIsExpanded((prev) => !prev)}
          className="text-blue-1 underline"
        >
          {isExpanded ? (
            <>
              View Less{" "}
              <small>
                <FontAwesomeIcon icon={faAngleUp} />
              </small>
            </>
          ) : (
            <>
              View More{" "}
              <small>
                <FontAwesomeIcon icon={faAngleDown} />
              </small>
            </>
          )}
        </button>
      )}
    </div>
  );
};

export default Description;
